export function PlusIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.57129 3.42871H8V4.57129H4.57129V8H3.42871V4.57129H0V3.42871H3.42871V0H4.57129V3.42871Z"
        fill="currentColor"
      />
    </svg>
  );
}
